import { getAccessTokenFromCookies, goToLoginWithRedirect } from 'auth';
import jwt from 'jsonwebtoken';
import { fetcher } from '@/endpoints/fionaMainApi';

export type Account = {
  id: string;
  name: string;
};

export type AccountUser = {
  accountId: string;
  id: string;
  role: string;
  roles: string[];
  flags: string[];
  account: Account;
};

export type AuthenticatedUser = {
  accountUsers: AccountUser[];
  user: {
    email: string;
    id: string;
    isSystemAdmin: boolean;
    name: string;
  };
};

export const fetchCurrentUser = (): AuthenticatedUser => {
  //extract from cookies
  const accessToken = getAccessTokenFromCookies();
  if (!accessToken) {
    goToLoginWithRedirect();
  }
  const obj = jwt.decode(accessToken) as any;
  if (!obj.user) {
    goToLoginWithRedirect();
  }
  return {
    user: {
      id: obj.user.id,
      name: obj.user.name,
      email: obj.user.email,
      isSystemAdmin: obj.user.isSystemAdmin,
    },
    accountUsers: obj.accountUsers,
  };
};

/**
 * Fetches fresh user flags from the API.
 * This is a lightweight endpoint that only returns account users with flags.
 */
export const fetchFlagsFromAPI = async (): Promise<{ accountUsers: AccountUser[] }> => {
  const response = await fetcher('/v1/users/flags');
  // Transform API response to match JWT structure (add accountId at top level)
  const accountUsers = response.accountUsers.map((au: any) => ({
    ...au,
    accountId: au.account.id, // Add accountId at top level for atom compatibility
  }));
  return {
    accountUsers,
  };
};
